exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper-th-sortable{width:100%;-webkit-column-gap:5px;column-gap:5px}.sort-icons,.wrapper-th-sortable{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.sort-icons{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;line-height:1;color:#c0c4cc}.sort-icons i{display:block;height:7px;line-height:7px;margin:.6px 0;padding:0;cursor:pointer;font-size:15px}.active-sort{color:#409eff}.name-th{cursor:pointer;font-weight:700;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.table-payments td{font-size:11px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a3ed52b","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/system/payments/components/table.vue
// module id = 9YOy
// module chunks = 0